export default __webpack_public_path__ + "static/media/violet-ball.18dc74b5.svg";